module.exports = __webpack_public_path__ + "static/media/title-hero-9.9eafde0a.jpg";